/*
* 忠诚度管理      
* */

import { post, postJson,get } from '../axios'

const RESOURCE_BASE_PATH = '/members-api/scoresCard';

const RESOURCE_BASE_PATH_rule = '/members-api/pointsRewardRule';

const BASE_PATH = '/members-api';

// 会员卡
export const list = p => postJson(`${RESOURCE_BASE_PATH}/list`, p);

// 会员卡列表查看
export const getDetailById = p => post(`${RESOURCE_BASE_PATH}/getDetailById`, p);

// 会员卡历史数据
export const histroyList = p => postJson(`${RESOURCE_BASE_PATH}/histroy/list`, p);

//查询昨日数据变化
export const getChangeYesterday = p => post(`${RESOURCE_BASE_PATH}/histroy/getChangeYesterday`, p);

//会员入会记录
export const page = p => postJson(`${RESOURCE_BASE_PATH}/registerRecord/page`, p);

//获取已关联的店铺列表
export const pageList = p => post(`${RESOURCE_BASE_PATH}/shop/list`, p);

//会员积分变更记录
export const pageMember  = p => postJson(`${RESOURCE_BASE_PATH}/updateRecord/page`, p);

//会员卡等级数据
export const gradeList  = p => post(`${RESOURCE_BASE_PATH}/grade/list`, p);

//修改会员卡等级信息
export const update  = p => postJson(`${RESOURCE_BASE_PATH}/grade/update`, p);

//修改会员卡名
export const rename  = p => post(`${RESOURCE_BASE_PATH}/rename`, p);

//新建会员卡
export const create  = p => post(`${RESOURCE_BASE_PATH}/create`, p);

//修改会员卡等级开关状态
export const setValid  = p => post(`${RESOURCE_BASE_PATH}/grade/setValid`, p);

//查询会员卡等级数据
export const getById  = p => post(`${RESOURCE_BASE_PATH}/grade/getById`, p);

//查询未关联的店铺列表
export const unbindList  = p => post(`${RESOURCE_BASE_PATH}/shop/unbind/list`, p);

//查询已关联店铺的列表
export const bindList  = p => post(`${RESOURCE_BASE_PATH}/shop/list`, p);

//关联店铺
export const relationShop = p => post(`${RESOURCE_BASE_PATH}/shop/bind`, p);

//解除关联店铺
export const shopUnbind = p => post(`${RESOURCE_BASE_PATH}/shop/unbind`, p);

//会员卡权益规则修改会员卡规则信息
export const ruleUpdate = p => postJson(`${RESOURCE_BASE_PATH}/rule/update`, p);

//会员卡权益查询会员卡规则详细信息
export const ruleDetail = p => post(`${RESOURCE_BASE_PATH}/rule/detail`, p);

//会员关联设置主店铺
export const setMajor = p => post(`${RESOURCE_BASE_PATH}/shop/setMajor`, p);

//重新关联
export const rebind = p => post(`${RESOURCE_BASE_PATH}/shop/rebind`, p);




//积分奖励规则

//查看积分奖励规则列表,取单个数据的
export const rewDetail = p => post(`${RESOURCE_BASE_PATH}/rewardRule/detail`, p);

//奖励规则开关,取多个数据
export const rewList = p => post(`${RESOURCE_BASE_PATH}/rewardRule/list`, p);

//添加奖励规则
export const insert = p => postJson(`${RESOURCE_BASE_PATH}/rewardRule/insert`, p);

//删除奖励规则
export const rewDelete = p => post(`${RESOURCE_BASE_PATH}/rewardRule/delete`, p);

//编辑奖励规则
export const rewUpdate = p => postJson(`${RESOURCE_BASE_PATH}/rewardRule/update`, p);

//修改会员卡奖励规则状态
export const updateStatus = p => post(`${RESOURCE_BASE_PATH}/rewardRule/updateStatus`, p);

//查询奖励规则计算方式 1:取最大分值 2:叠加分值奖励
export const getRewardType = p => post(`${RESOURCE_BASE_PATH}/rewardRule/getRewardType`, p);

//修改奖励规则计算方式
export const updateRewardType = p => post(`${RESOURCE_BASE_PATH}/rewardRule/updateRewardType`, p);


// 等级
// 等级计算规则列表
export const getGradeList = p => post(`${BASE_PATH}/scoresGradeCardRule/list`, p);

//修改保存
export const saveGrade = p => postJson(`${BASE_PATH}/scoresGradeCardRule/update`, p);

//查询会员卡等级升级类型 /scoresCard/grade/getScoresCardUpRuleType
export const getScoresCardUpRuleType = p => get(`${RESOURCE_BASE_PATH}/grade/getScoresCardUpRuleType`, p);

//查询会员卡等级升级类型 /scoresCard/grade/up-rule-switch
export const upRuleSwitch = p => postJson(`${RESOURCE_BASE_PATH}/grade/up-rule-switch`, p);


// 查询会员卡行为等级规则详情 /scoresCard/grade/rule/detail
export const getDetail = p => get(`${RESOURCE_BASE_PATH}/grade/rule/detail`, p);

// 更新会员卡行为等级规则详情 /scoresCard/grade/rule/save
export const ruleSave = p => postJson(`${RESOURCE_BASE_PATH}/grade/rule/save`, p);






























